// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"fd3868fc42e3688396f0","293":"052090a3eaf65ddbb5d2","878":"79ec6d0dd8b628dee9b4"}[chunkId] + ".js";
};